/* JESCUTT demo — interactions (vanilla, self-contained) */
(function(){
  'use strict';
  const $ = (s,c=document)=>c.querySelector(s);
  const $$ = (s,c=document)=>Array.from(c.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- sticky nav state ---- */
  const nav = $('.nav');
  const onNav = ()=>{ if(nav) nav.classList.toggle('scrolled', window.scrollY>24); };
  onNav(); window.addEventListener('scroll', onNav, {passive:true});

  /* ---- mobile menu ---- */
  const burger = $('.nav__burger'), links = $('.nav__links');
  if(burger&&links){ burger.addEventListener('click',()=>{links.classList.toggle('open');burger.classList.toggle('is-open');});
    $$('.nav__links a').forEach(a=>a.addEventListener('click',()=>{links.classList.remove('open');burger.classList.remove('is-open');})); }

  /* ---- reveal on scroll — BULLETPROOF (never leaves content invisible) ---- */
  const revealEls = $$('.reveal');
  const show = el => el.classList.add('in');
  if(reduce){ revealEls.forEach(show); }
  else {
    const io = new IntersectionObserver((entries,obs)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ show(e.target); obs.unobserve(e.target); } });
    },{threshold:0.01, rootMargin:'0px 0px -6% 0px'});
    revealEls.forEach(el=>io.observe(el));
    // Failsafe #1: reveal anything already in / near the viewport right now (on load + scroll)
    const sweep = ()=>{ const vh=innerHeight; revealEls.forEach(el=>{
      if(el.classList.contains('in')) return;
      const r=el.getBoundingClientRect(); if(r.top < vh*0.94 && r.bottom > 0) show(el);
    }); };
    addEventListener('scroll', sweep, {passive:true});
    addEventListener('load', sweep);
    sweep();
    // Failsafe #2: nothing may stay hidden — hard reveal anything left after 2.6s
    setTimeout(()=>revealEls.forEach(show), 2600);
  }

  /* ---- count-up stats ---- */
  const countIO = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(!e.isIntersecting) return;
      const el=e.target, target=parseFloat(el.dataset.count), dec=(el.dataset.dec|0), suf=el.dataset.suf||'';
      if(reduce){ el.textContent=(dec?target.toFixed(dec):Math.round(target).toLocaleString())+suf; countIO.unobserve(el); return; }
      let start=null, dur=1400;
      const step=(t)=>{ if(!start)start=t; const p=Math.min((t-start)/dur,1);
        const val=(target*(1-Math.pow(1-p,3)));
        el.textContent=(dec?val.toFixed(dec):Math.round(val).toLocaleString())+suf;
        if(p<1) requestAnimationFrame(step); };
      requestAnimationFrame(step); countIO.unobserve(el);
    });
  },{threshold:0.5});
  $$('[data-count]').forEach(el=>countIO.observe(el));

  /* ---- animated rating bars (fill on view) ---- */
  const barShow = new IntersectionObserver((en)=>en.forEach(e=>{ if(e.isIntersecting){ e.target.style.width=e.target.dataset.w; barShow.unobserve(e.target);} }),{threshold:.4});
  $$('.ratebar .fill').forEach(f=>{ f.dataset.w=f.style.width; if(!reduce){ f.style.transition='width 1.1s cubic-bezier(.22,.61,.36,1)'; f.style.width='0'; barShow.observe(f);} });

  /* ---- FAQ accordion ---- */
  $$('.acc__q').forEach(q=>{
    q.addEventListener('click',()=>{
      const item=q.closest('.acc__item'), ans=$('.acc__a',item), open=item.classList.contains('open');
      $$('.acc__item.open').forEach(o=>{ if(o!==item){o.classList.remove('open'); $('.acc__a',o).style.maxHeight=null;} });
      item.classList.toggle('open',!open);
      ans.style.maxHeight = open ? null : ans.scrollHeight+'px';
    });
  });

  /* ---- before/after slider (Pointer Events + capture = bulletproof drag) ---- */
  $$('.ba-slider').forEach(sl=>{
    const after=$('.ba-after',sl), handle=$('.ba-handle',sl);
    let dragging=false;
    const set=(clientX)=>{ const r=sl.getBoundingClientRect(); let p=((clientX-r.left)/r.width)*100; p=Math.max(1,Math.min(99,p));
      after.style.clipPath=`inset(0 0 0 ${p}%)`; handle.style.left=p+'%'; };
    const first=()=>sl.classList.add('touched');
    // init at 50 (before on the left, after revealed on the right)
    after.style.clipPath='inset(0 0 0 50%)';
    sl.addEventListener('pointerdown',(e)=>{ dragging=true; first(); try{ sl.setPointerCapture(e.pointerId); }catch(_){}
      set(e.clientX); e.preventDefault(); });
    sl.addEventListener('pointermove',(e)=>{ if(dragging){ set(e.clientX); e.preventDefault(); } });
    const end=(e)=>{ dragging=false; try{ sl.releasePointerCapture(e.pointerId); }catch(_){} };
    sl.addEventListener('pointerup',end); sl.addEventListener('pointercancel',end);
    sl.addEventListener('lostpointercapture',()=>dragging=false);
    sl.tabIndex=0; sl.setAttribute('role','slider'); sl.setAttribute('aria-label','Before and after — drag to compare');
    sl.addEventListener('keydown',(e)=>{ const cur=parseFloat(handle.style.left)||50, r=sl.getBoundingClientRect();
      if(e.key==='ArrowLeft'){ first(); set(r.left+r.width*(cur-4)/100); e.preventDefault(); }
      if(e.key==='ArrowRight'){ first(); set(r.left+r.width*(cur+4)/100); e.preventDefault(); } });
  });

  /* ---- PDP gallery ---- */
  $$('.gal-thumbs button').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const main=$('.gal-main img'); const src=btn.dataset.src, contain=btn.classList.contains('contain');
      $$('.gal-thumbs button').forEach(b=>b.classList.remove('active')); btn.classList.add('active');
      main.style.opacity=0; setTimeout(()=>{ main.src=src; main.style.opacity=1;
        main.style.objectFit = contain?'contain':'cover';
        main.style.width = contain?'80%':'100%'; main.style.height = contain?'80%':'100%';
        main.style.filter = contain?'drop-shadow(0 30px 40px rgba(60,40,20,.26))':'none'; },180);
    });
  });

  /* ---- qty stepper ---- */
  $$('.qty').forEach(q=>{
    const span=$('span',q), [minus,plus]=$$('button',q);
    let n=parseInt(span.textContent)||1;
    minus.addEventListener('click',()=>{n=Math.max(1,n-1);span.textContent=n;});
    plus.addEventListener('click',()=>{n++;span.textContent=n;});
  });

  /* ---- add to cart + toast (Shopify-wired) ---- */
  let cart=0; const count=$('.cart-count'); const toast=$('.toast'), toastText=$('.toast span');
  let toastT;
  const JV = window.JVARIANTS || null;
  const bump=()=>{ if(count) count.animate([{transform:'scale(1.5)'},{transform:'scale(1)'}],{duration:400,easing:'cubic-bezier(.34,1.56,.64,1)'}); };
  const showToast=(name)=>{ if(toast){ toastText.textContent=`Added ${name} to your bag`; toast.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(()=>toast.classList.remove('show'),2600); } };
  const refreshCount=()=>{ if(!count||!JV) return; fetch('/cart.js').then(r=>r.json()).then(c=>{count.textContent=c.item_count; bump();}).catch(()=>{}); };
  const jvItems=(name)=>{ if(!JV) return []; if(JV.bundles && JV.bundles[name]) return JV.bundles[name].map(id=>({id,quantity:1})); const id=JV.byName&&JV.byName[name]; return id?[{id,quantity:1}]:[]; };
  window.jescuttAdd=(name,qtySel)=>{
    let add=1; if(qtySel){ const s=$(qtySel+' .qty span'); if(s) add=parseInt(s.textContent)||1; }
    if(JV){
      let items=jvItems(name); if(!items.length){ showToast(name); return; }
      items=items.map(it=>({id:it.id, quantity:it.quantity*add}));
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
        .then(()=>{ refreshCount(); showToast(name); }).catch(()=>{ showToast(name); });
    } else {
      cart+=add; if(count){count.textContent=cart; bump();} showToast(name);
    }
  };
  $$('[data-add]').forEach(b=>b.addEventListener('click',(e)=>{ e.preventDefault(); const n=b.dataset.add; if(JV && (b.classList.contains('cart-btn')||n==='your bag')){ location.href='/cart'; return; } window.jescuttAdd(n, b.dataset.qty); }));
  $$('.cart-btn').forEach(b=>{ if(JV) b.addEventListener('click',(e)=>{ e.preventDefault(); location.href='/cart'; }); });
  /* Buy it now: add, then straight to checkout. Was a dead button before 2026-09-08. */
  $$('[data-buynow]').forEach(b=>b.addEventListener('click',(e)=>{ e.preventDefault();
    const n=b.dataset.buynow; if(!JV){ showToast(n); return; }
    let add=1; const s=$('.buybox .qty span'); if(s) add=parseInt(s.textContent)||1;
    let items=jvItems(n); if(!items.length){ showToast(n); return; }
    items=items.map(it=>({id:it.id, quantity:it.quantity*add}));
    b.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
      .then(()=>{ location.href='/checkout'; }).catch(()=>{ b.disabled=false; showToast(n); }); }));
  if(JV) refreshCount();

  /* ---- subscription option toggle (PDP) ---- */
  $$('.opt').forEach(opt=>opt.addEventListener('click',()=>{
    $$('.opt').forEach(o=>o.classList.remove('sel')); opt.classList.add('sel');
    const r=$('input',opt); if(r)r.checked=true;
  }));

  /* ---- sticky mobile ATC ---- */
  const atc=$('.atc-bar'), buybox=$('.buybox');
  if(atc&&buybox){
    const atcIO=new IntersectionObserver((en)=>{en.forEach(x=>atc.classList.toggle('show',!x.isIntersecting));},{threshold:0});
    atcIO.observe(buybox);
  }

  /* ---- newsletter fake submit ---- */
  $$('.news form,[data-news]').forEach(f=>f.addEventListener('submit',(e)=>{e.preventDefault();
    const btn=$('button',f); if(btn){btn.textContent='Welcome in ✦';btn.disabled=true;}
  }));

  /* ---- hero parallax (pointer + scroll, transform only) ---- */
  if(!reduce){
    const media=$('.hero__media'), floatc=$('.hero__float'), blob=$('.hero__blob');
    const hero=$('.hero');
    if(hero&&media){
      hero.addEventListener('pointermove',(e)=>{
        const r=hero.getBoundingClientRect(); const x=(e.clientX-r.left)/r.width-0.5, y=(e.clientY-r.top)/r.height-0.5;
        media.style.transform=`translate3d(${x*-14}px,${y*-14}px,0)`;
        if(floatc) floatc.style.transform=`translate3d(${x*22}px,${y*18}px,0)`;
        if(blob) blob.style.transform=`translate3d(${x*30}px,${y*24}px,0) rotate(-8deg)`;
      });
      hero.addEventListener('pointerleave',()=>{ media.style.transform=''; if(floatc)floatc.style.transform=''; if(blob)blob.style.transform='rotate(-8deg)'; });
    }
  }

  /* ---- scroll progress bar ---- */
  const bar=document.createElement('div'); bar.className='scrollbar'; document.body.appendChild(bar);
  const setBar=()=>{ const h=document.documentElement.scrollHeight-innerHeight; bar.style.width=(h>0?(scrollY/h*100):0)+'%'; };
  addEventListener('scroll',setBar,{passive:true}); setBar();

  /* ---- inject drifting motif sprites into hero + CTA (no HTML edits needed) ---- */
  if(!reduce){
    const SPR = {
      drop:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'><path d='M12 3c3 4 6 7 6 10.5A6 6 0 116 13.5C6 10 9 7 12 3z'/></svg>",
      leaf:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'><path d='M4 20c0-8 6-14 16-14 0 10-6 16-14 16-.7 0-1.3 0-2-.1z'/><path d='M4 20C8 14 12 11 17 9'/></svg>",
      sun:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round'><circle cx='12' cy='12' r='4'/><path d='M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4'/></svg>",
      spark:"<svg viewBox='0 0 24 24' fill='currentColor'><path d='M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6z'/></svg>"
    };
    const kinds=['drop','leaf','sun','spark','drop'];
    $$('.hero, .guarantee').forEach(host=>{
      const layer=document.createElement('div'); layer.className='spores'; layer.setAttribute('aria-hidden','true');
      kinds.forEach((k,i)=>{ const s=document.createElement('span'); s.className='spore s'+(i+1); s.innerHTML=SPR[k]; layer.appendChild(s); });
      host.insertBefore(layer, host.firstChild);
    });
  }
})();
